import { ThemeProvider as MuiThemeProvider } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers-pro";
import { LicenseInfo } from "@mui/x-license-pro";

import { AdapterLuxonLocaleWeeks } from "./AdapterLuxonLocaleWeeks";
import { theme } from "./theme/theme";

if (!LicenseInfo.getLicenseKey()) {
  LicenseInfo.setLicenseKey(
    "c21ec6dd1dd33bf0a6f2fdebc70b5f9cTz0xMTU4NzAsRT0xNzg0ODUxMTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=",
  );
}

export const ThemeProvider = ({ children }: React.PropsWithChildren) => {
  // Use browser's locale or fallback to en-US; force Sunday-first for en-US via Unicode extension (fw=sun)
  const browserLocale = navigator?.language || "en-US";
  const locale = browserLocale.toLowerCase() === "en-us" ? `${browserLocale}-u-fw-sun` : browserLocale;

  return (
    <LocalizationProvider dateAdapter={AdapterLuxonLocaleWeeks} adapterLocale={locale}>
      <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>
    </LocalizationProvider>
  );
};
